import html2canvas from "html2canvas";
import moment from "moment";
import CryptoJS from "crypto-js";

export function formatLoginSetting({
  result,
  option_authority_action = null,
  dispatch,
  setUserControl,
  setUser,
}) {
  const formatAuthority = ({ data }) => {
    let temp = {};
    data?.forEach((setting) => {
      setting = JSON.parse(setting);

      Object.entries(setting)?.forEach(([mainKey, mainData]) => {
        if (!temp[mainKey]) temp[mainKey] = {};
        temp[mainKey].status = 0; // 預設模組未啟用
        temp[mainKey].enabled = mainData?.enabled ?? false;

        Object.entries(mainData)?.forEach(([subKey, subData]) => {
          if (!temp[mainKey][subKey])
            temp[mainKey][subKey] = { enabled: false };
          if (subData?.enabled) temp[mainKey][subKey].enabled = true;

          if (subKey === "carbonInventory") {
            // 碳盤查
            let typeData = ["boundary", "setup", "year"]; // 邊界、設定、年度
            typeData.forEach((typeKey) => {
              if (!temp[mainKey][subKey][typeKey]) {
                temp[mainKey][subKey][typeKey] = {};

                option_authority_action.forEach((action) => {
                  temp[mainKey][subKey][typeKey][action.value] = false;
                });
              }

              option_authority_action.forEach((action) => {
                if (subData?.[typeKey]?.[action.value])
                  temp[mainKey][subKey][typeKey][action.value] = true;
              });
            });

            // 設定廠區 c1-c6
            if (!temp[mainKey][subKey].boundaryAddress)
              temp[mainKey][subKey].boundaryAddress = {
                list: subData.boundaryAddress, // 可用 廠區清單
                list_str: subData.boundaryAddress?.join(",") ?? null,
              };
            subData.boundaryAddress?.forEach((boundaryAddressid) => {
              let categoryData = ["c1", "c2", "c3", "c4", "c5", "c6"];
              if (!temp[mainKey][subKey].boundaryAddress[boundaryAddressid]) {
                temp[mainKey][subKey].boundaryAddress[boundaryAddressid] = {};

                categoryData.forEach((categoryKey) => {
                  temp[mainKey][subKey].boundaryAddress[boundaryAddressid][
                    categoryKey
                  ] = {};

                  option_authority_action.forEach((action) => {
                    temp[mainKey][subKey].boundaryAddress[boundaryAddressid][
                      categoryKey
                    ][action.value] = false;
                  });
                });
              }

              categoryData.forEach((categoryKey) => {
                option_authority_action.forEach((action) => {
                  if (subData?.[categoryKey]?.[action.value])
                    temp[mainKey][subKey].boundaryAddress[boundaryAddressid][
                      categoryKey
                    ][action.value] = true;
                });
              });
            });
          }
        });
      });
    });

    return temp;
  };

  result.now = moment().format("YYYY/MM/DD HH:mm:ss");

  let authority = option_authority_action
    ? formatAuthority({
        data: result.ag_setting?.setting,
      })
    : {};

  // 依照資料庫設定 啟用模組
  result.sms_data_obj = {};
  result.sms_data.forEach((item) => {
    if (!authority[item.key_name]) authority[item.key_name] = {};
    authority[item.key_name].status = item.status;

    result.sms_data_obj[item.key_name] = item;
  });

  result.sms_data.sort(function (pre, next) {
    return pre.orders - next.orders;
  });

  // 身分類型 3(admin)、8(主控台)、9(team) 可使用全部功能
  if ([3, 8, 9].indexOf(result.type) !== -1) {
    authority.isAllow = true;
  }
  result.authority = authority;

  if (result.sccs === 1) dispatch(setUserControl(result));
  else {
    dispatch(setUserControl(null));
    dispatch(setUser(result));
  }
}

// 取得 cookie 值
export function getCookie(name) {
  const cookieVal = `; ${document.cookie}`;
  const parts = cookieVal.split(`; ${name}=`);
  if (parts.length >= 2) return parts.pop().split(";").shift();
  return "";
}

// 取得 url search
export function getUrlSearch(name, search) {
  const parts = search.split(`${name}=`);
  if (parts.length >= 2) {
    return parts.pop().split("&")[0];
  }
  return "";
}

// 排除 JSON 資料
export function excludeJSON(data, exclude) {
  let temp = { ...data };
  exclude.forEach((item) => {
    delete temp[item];
  });

  return temp;
}

// 設定 formData 資料
export function formatFormData(data) {
  let formData = new FormData();
  Object.entries(data).forEach(([name, value]) => {
    formData.append(name, value);
  });

  return formData;
}

// 設定回傳資料
export function formatResData(oldData, newData) {
  let temp = { ...oldData };
  Object.entries(temp).forEach(([key, val]) => {
    if (
      newData[key] !== null &&
      newData[key] !== undefined &&
      newData[key] !== ""
    ) {
      temp[key] = newData[key];
    }
  });

  return temp;
}

// 排除obj內無資料的項目
export function cleanObj(data) {
  let temp = {};
  Object.entries(data).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      temp[key] = value;
    }
  });

  return temp;
}

export function cleanEmpty(data) {
  let temp = {};
  Object.entries(data).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== "") {
      temp[key] = value;
    }
  });

  return temp;
}

export function cleanEmptyArray(data) {
  let temp = {};
  Object.entries(data).forEach(([key, value]) => {
    if (value.length > 0 || key.indexOf("noback") !== -1) {
      temp[key] = value;
    }
  });

  return temp;
}

// 轉換options資料
export function formatOptions(
  rawData,
  {
    uniqueKey = "value",
    showValue = null,
    showLabel = "label",
    childKey = "child",
    prefixKey = null,
  } = {}
) {
  let tempObj = {},
    nowPrefix = "";

  if (!showValue) showValue = uniqueKey;

  function formatOption(data, items, layer) {
    items.forEach((item) => {
      if (layer === 0 && prefixKey) {
        nowPrefix = item[prefixKey];
      }

      item["showLabel"] = item[showLabel];
      item["showValue"] = item[showValue];

      data[
        `${layer !== 0 && nowPrefix ? `${nowPrefix}_` : ""}${String(
          item[uniqueKey]
        ).trim()}`
      ] = item;

      if (item[childKey]) {
        formatOption(data, item[childKey], layer + 1);
      }
    });
  }

  Object.entries(rawData).forEach(([name, value]) => {
    tempObj[`${name}_obj`] = {};
    formatOption(tempObj[`${name}_obj`], value, 0);
  });

  return { ...rawData, ...tempObj };
}

// 確認欄位是否有值
export function checkColumnVal(val) {
  if (typeof val === "string") val = val.trim();

  return !(val === null || val === undefined || val === "");
}

// 確認表單是否更新
export function checkFormUpdate(newData, rawData) {
  return Object.entries(newData).some(([key, val]) => {
    if (
      (rawData[key] === null ||
        rawData[key] === undefined ||
        rawData[key] === "") &&
      (val === null || val === undefined || val === "")
    ) {
      return false;
    }

    return rawData[key] != val;
  });
}

// 下載
export function exportFile(url, filename) {
  let ext = url.split(".");
  ext = ext[ext.length - 1];

  let link = document.createElement("a");
  document.body.appendChild(link);
  link.href = url;
  link.download = `${filename}.${ext}`;
  link.target = "_blank";
  link.click();
  document.body.removeChild(link);
}

// 列表 page 參數設定
export function setPageSetting(data) {
  let pageSetting = sessionStorage.getItem("pageSetting");
  if (pageSetting) pageSetting = JSON.parse(pageSetting);

  let temp = data;
  if (pageSetting && pageSetting.page?.indexOf(data.page) !== -1) {
    temp = {
      page: data.page,
      tab: data.tab ?? null,
      params: {
        ...pageSetting.params,
        ...temp.params,
      },
    };
  }
  sessionStorage.setItem("pageSetting", JSON.stringify(temp));
}

// 取得 列表 page 參數
export function getPageSetting(page) {
  let pageSetting = sessionStorage.getItem("pageSetting");
  if (pageSetting) pageSetting = JSON.parse(pageSetting);
  if (pageSetting && page.indexOf(pageSetting.page) !== -1) return pageSetting;

  return null;
}

// excel 日期傳換
export function parseExcelDateToDate(serial) {
  let utc_days = Math.floor(serial - 25569);
  let utc_value = utc_days * 86400;
  let date_info = new Date(utc_value * 1000);

  let fractional_day = serial - Math.floor(serial) + 0.0000001;

  let total_seconds = Math.floor(86400 * fractional_day);

  let seconds = total_seconds % 60;

  total_seconds -= seconds;

  let hours = Math.floor(total_seconds / (60 * 60));
  let minutes = Math.floor(total_seconds / 60) % 60;

  return new Date(
    date_info.getFullYear(),
    date_info.getMonth(),
    date_info.getDate(),
    hours,
    minutes,
    seconds
  );
}

// 數字切割(逗號、千分位)
export function splitNumber(number) {
  let [numInteger, numDecimal] = String(number).split("."); // 原數字轉字串
  let tempCount = Math.floor(numInteger.length / 3); // 有幾組3位數
  let tempRemain = numInteger.length % 3; // 多幾位，放逗號左側
  let reStr = "";

  for (let i = 0; i < tempRemain; i++) {
    // 位數不為3的倍數，先將多餘的產生，之後再併逗號產生後續數字
    reStr += String(numInteger[i]);
  }

  for (let i = 0; i < tempCount; i++) {
    if ((tempRemain == 0 && i > 0) || tempRemain != 0) {
      // 位數為3的倍數，第一組前面不加逗號 || 位數不為3的倍數
      reStr += ",";
    }

    reStr += String(numInteger[tempRemain + 0 + 3 * i]);
    reStr += String(numInteger[tempRemain + 1 + 3 * i]);
    reStr += String(numInteger[tempRemain + 2 + 3 * i]);
  }

  if (tempCount == 0) {
    reStr = number;
  } else if (numDecimal) {
    reStr += `.${numDecimal}`;
  }

  return reStr;
}

// 身分證驗證
export function idCardCheck(idCard) {
  //建立字母分數陣列(A~Z)
  let city = new Array(
    1,
    10,
    19,
    28,
    37,
    46,
    55,
    64,
    39,
    73,
    82,
    2,
    11,
    20,
    48,
    29,
    38,
    47,
    56,
    65,
    74,
    83,
    21,
    3,
    12,
    30
  );
  idCard = idCard.toUpperCase();
  //使用「正規表達式」檢驗格式
  if (idCard.search(/^[A-Z][1-28-9A-D]\d{8}$/i) === -1) {
    return false;
  } else {
    //將字串分割為陣列(IE必需這麼做才不會出錯)
    let word = idCard.split("");
    let total = 0;
    if (idCard.search(/^[A-Z][1-28-9]\d{8}$/i) !== -1) {
      // 新版身分證
      total = city[word[0].charCodeAt(0) - 65];
      for (let i = 1; i <= 8; i++) {
        total += Number(word[i]) * (9 - i);
      }
      //補上檢查碼(最後一碼)
      total += Number(word[9]);
    } else if (idCard.search(/^[A-Z][A-D]\d{8}$/i) !== -1) {
      // 舊版身分證
      let conver = "ABCDEFGHJKLMNPQRSTUVXYWZIO";
      let weights = [1, 9, 8, 7, 6, 5, 4, 3, 2, 1, 1];
      idCard =
        String(conver.indexOf(idCard[0]) + 10) +
        String((conver.indexOf(idCard[1]) + 10) % 10) +
        idCard.slice(2);
      word = idCard.split("");
      for (let i = 0; i < word.length; i++) {
        let c = parseInt(word[i]);
        let w = weights[i];
        total += c * w;
      }
    }

    //檢查比對碼(餘數應為0);
    if (total % 10 !== 0) {
      return false;
    }
  }
  return true;
}

export function formatNumber(data) {
  return Number(data ?? 0);
}

export function formatDate(data, format = "YYYY/MM/DD") {
  return data ? moment(data).format(format) : "";
}

// 小數補0
export function decimalAddZero({
  rawVal = 0,
  decimalCount = 0,
  decimalShowRaw = false,
  isZero = true,
} = {}) {
  // 若超出小數點位數，四捨五入
  let pow = Math.pow(10, decimalCount);
  rawVal = decimalShowRaw ? rawVal : Math.round(rawVal * pow) / pow;

  // 是否為負數
  let isNegative = rawVal < 0;
  rawVal = Math.abs(rawVal);

  // 分割 整數位 小數位
  let temp = String(rawVal),
    [intVal, doubleVal = ""] = temp.split(".");
  intVal = splitNumber(intVal);

  // 若小數位數不夠，補0
  let finalDouble = doubleVal;
  if (isZero && !decimalShowRaw && doubleVal.length < decimalCount) {
    for (let i = doubleVal.length; i < decimalCount; i++) finalDouble += "0";
  }

  let finalVal = intVal;
  if ((decimalCount > 0 || decimalShowRaw) && finalDouble)
    finalVal = intVal + "." + finalDouble;

  if (isNegative) finalVal = "-" + finalVal;

  return finalVal;
}

export function base64DataURLToArrayBuffer(dataURL) {
  const base64Regex = /^data:image\/(png|jpg|svg|jpeg|svg\+xml);base64,/;
  if (!base64Regex.test(dataURL)) {
    return false;
  }
  const stringBase64 = dataURL.replace(base64Regex, "");
  let binaryString;
  if (typeof window !== "undefined") {
    binaryString = window.atob(stringBase64);
  } else {
    binaryString = new Buffer(stringBase64, "base64").toString("binary");
  }
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    const ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes.buffer;
}

// url to base64
export function anyGetBase64(url, callback) {
  let Img = new Image(),
    dataURL = "";

  Img.src = url + "?t=" + new Date().valueOf(); // 处理缓存,fix缓存bug,有缓存，浏览器会报错;

  Img.setAttribute("crossOrigin", "Anonymous"); // 解决控制台跨域报错的问题

  return new Promise((resolve, reject) => {
    Img.onload = function () {
      //要先确保图片完整获取到，这是个异步事件

      let canvas = document.createElement("canvas"), //创建canvas元素
        width = Img.width, //确保canvas的尺寸和图片一样
        height = Img.height;

      canvas.width = width;

      canvas.height = height;

      canvas.getContext("2d").drawImage(Img, 0, 0, width, height); //将图片绘制到canvas中

      dataURL = canvas.toDataURL("image/png"); //转换图片为dataURL

      // callback ? callback(dataURL) : null; //调用回调函数

      resolve(dataURL);
    };
  });
}

// dataURL to File
export function dataURLtoFile(dataurl, filename) {
  let arr = dataurl.split(","),
    // mime = arr[0].match(/:(.*?);/)[1],
    mime = arr[0].split(":")[1].split(";")[0],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

export function dataURLtoBase64(dataURL) {
  return dataURL.replace("data:", "").replace(/^.+,/, "");
}

const canvasToBlob = async (canvas) => {
  return new Promise((resolve) => {
    canvas.toBlob((blob) => {
      resolve(blob);
    });
  });
};

export function blobToBase64(blob) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}

// 截圖 (html)
export async function convertToCanvas({ targetId }) {
  let target = document.getElementById(targetId);

  return await html2canvas(target, {
    backgroundColor: null,
    allowTaint: true,
    useCORS: true,
  }).then(async (canvas) => {
    let pngData = canvas.toDataURL("image/png");

    let blob = await canvasToBlob(canvas);

    return {
      pngData: pngData,
      file: dataURLtoFile(pngData, "map.png"),
      blob,
    };
  });
}

// 加密
export const handleEncrypt = ({ CRYPTO_KEY, text } = {}) => {
  const key = CryptoJS.enc.Hex.parse(CryptoJS.SHA256(CRYPTO_KEY).toString());
  const iv = CryptoJS.lib.WordArray.random(16);

  const encrypted = CryptoJS.AES.encrypt(text, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return `${iv.toString(CryptoJS.enc.Hex)}:${encrypted.toString()}`;
};

// 解密
export const handleDecrypt = ({ CRYPTO_KEY, text } = {}) => {
  const SHA256 = CryptoJS.SHA256(CRYPTO_KEY).toString();
  const [ivHex, cipher] = String(text).split(":");
  const iv = CryptoJS.enc.Hex.parse(ivHex);

  return CryptoJS.AES.decrypt(cipher, CryptoJS.enc.Hex.parse(SHA256), {
    mode: CryptoJS.mode.CBC,
    iv: iv,
    padding: CryptoJS.pad.Pkcs7,
  }).toString(CryptoJS.enc.Utf8);
};

export const copyToClipboard = async ({
  text,
  errorAction = () => {},
} = {}) => {
  if (navigator.clipboard && window.isSecureContext) {
    await navigator.clipboard.writeText(text);
  } else {
    // Use the 'out of viewport hidden text area' trick
    const textArea = document.createElement("textarea");
    textArea.value = text;

    // Move textarea out of the viewport so it's not visible
    textArea.style.position = "absolute";
    textArea.style.left = "-999999px";

    document.body.prepend(textArea);
    textArea.select();

    try {
      document.execCommand("copy");
    } catch {
      errorAction();
    } finally {
      textArea.remove();
    }
  }
};

export const generateSerialArray = (start, end) => {
  return Array.from(Array(end - start + 1).keys(), (index) => index + start);
};
